import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M8.33333 0C3.75 0 0 3.75 0 8.33333C0 12.9167 3.75 16.6667 8.33333 16.6667C12.9167 16.6667 16.6667 12.9167 16.6667 8.33333C16.6667 3.75 12.9167 0 8.33333 0ZM11.9167 6.33333L8.08333 11.3333C7.91667 11.5 7.66667 11.6667 7.41667 11.6667C7.16667 11.6667 6.91667 11.5833 6.75 11.3333L4.75 8.75C4.5 8.41667 4.5 7.83333 4.91667 7.58333C5.33333 7.33333 5.83333 7.33333 6.08333 7.75L7.41667 9.5L10.5833 5.33333C10.8333 5 11.4167 4.91667 11.75 5.16667C12.1667 5.41667 12.1667 5.91667 11.9167 6.33333Z"
      fill="#02BC7D"
    />
  </Svg>
);
export default SVGComponent;
